module.exports = __webpack_public_path__ + "img/logo-colored-horizontal.4fc37c8b.svg";